export default __webpack_public_path__ + "static/media/san-rafael-5.04b632cd.jpg";